import React, { Fragment, useState } from "react";
import { useTranslation } from "react-i18next";

function ShowAddNew(props) {
    const {
        formik,
        hideNewAdd
    } = props;

    const { t } = useTranslation();

    const [newName, setNewName] = useState('');
    const [newValue, setNewValue] = useState('');
    const [errorMessage, setErrorMessage] = useState(null);

    const handleAdd = () => {
        if (newName === '' || newValue === '') {
            setErrorMessage(t('Values are invalid'));
        } else {
            let currentValues = formik.values['additional_info'] || {};
            const newAddInfo = { ...currentValues };
            newAddInfo[newName] = newValue;
            formik.setFieldValue('additional_info', newAddInfo);
            setNewName('');
            setNewValue('');
            hideNewAdd();
        }
    }

    return (
        <>
            <div className="additional-value">
                <label htmlFor={`fform_additional_info_name`} className="">{t('name')}</label>
                <input
                    color="tertiary"
                    type="text"
                    id="fform_additional_info_name"
                    value={newName}
                    onChange={(evt) => { setNewName(evt.target.value) }}
                />
                <label htmlFor={`fform_additional_info_value`} className="">{t('value')}</label>
                <input
                    color="tertiary"
                    type="text"
                    id="fform_additional_info_value"
                    value={newValue}
                    onChange={(evt) => { setNewValue(evt.target.value) }}
                />
                <span className="add-icon" onClick={handleAdd}><i className="tf-icon bx bx-chevron-right"></i></span>

            </div>
            {errorMessage && <div className="error-message">{errorMessage}</div>}
        </>

    )
}

function ShowExistents(props) {
    const {
        formik,
    } = props;

    var addInfo;

    const { t } = useTranslation();

    const handleChange = (evt, fieldName) => {
        if (addInfo) {
            addInfo[fieldName] = evt.target.value;
            formik.setFieldValue('additional_info', JSON.stringify(addInfo));
        }
    }

    try {
        addInfo = formik.values['additional_info'];
        const addInfoKeys = Object.keys(addInfo);

        return (
            <div className="additional-info-form" >
                {
                    addInfoKeys && addInfoKeys.map(x => (
                        <div key={`afform_additional_info_${x}`} className="additional-value">
                            <label htmlFor={`fform_additional_info_value`} className="">{t(x)}</label>
                            <input
                                color="tertiary"
                                type="text"
                                id="fform_additional_info_value"
                                value={addInfo[x] || ''}
                                sx={{ width: 280 }}
                                onChange={(evt) => { handleChange(evt, x) }}
                            />
                        </div>
                    ))
                }

            </div>
        )
    } catch (err) {
        return (<Fragment></Fragment>)
    }
}

function AditionalInfoForm(props) {
    const {
        formik,
        sended
    } = props;

    const [addNewValue, setAddNewValue] = useState(false);

    const { t } = useTranslation();

    const handleAdd = () => {
        setAddNewValue(true);
    }

    const hideNewAdd = () => {
        setAddNewValue(false);
    }

    return (
        <div className="additional-info-form">
            <div>
                {t('additional_info')}
            </div>
            <span className="add-icon" onClick={handleAdd}><i className="tf-icon bx bx-plus"></i></span>
            {
                addNewValue &&
                <ShowAddNew
                    formik={formik}
                    sended={sended}
                    hideNewAdd={hideNewAdd}
                />
            }
            <ShowExistents
                formik={formik}
                sended={sended}
            />
        </div>
    )
}

export default AditionalInfoForm;